export default __webpack_public_path__ + "static/media/perksBenefitsIcon3.2536bb49.png";